/* eslint-disable no-plusplus */
import Swiper from 'swiper';
// import { Navigation } from 'swiper/modules';
import Base from '../../_config/base';

class Timeline extends Base {
  constructor(el) {
    super(el);

    const timeline = el.querySelector('.timeline__column');

    const sliderOpt = {
      // configure Swiper to use modules
      direction: 'vertical',
      freeMode: true,
      // centeredSlides: true,
      effect: 'fade',
      speed: 500,
      longSwipes: true,
      slidesPerView: 'auto',
      // mousewheelControl: true,
      // freeMode: true,
      // freeModeSticky: true,
      // Navigation arrows
      // navigation: {
      //   nextEl: '.swiper-button-nextTimestamp',
      //   prevEl: '.swiper-button-prevTimestamp',
      // },
    };

    // const setSliderButtonsPosition = () => {
    //   // set position of slider buttons to the center based on second row height
    //   const rowHeight = secondRowCard.offsetHeight;
    //   sliderButtons.forEach((button) => {
    //     button.style.bottom = `${rowHeight - 24}px`;
    //   });
    // };

    if (timeline) {
      // eslint-disable-next-line
      const swiper = new Swiper(timeline, sliderOpt);
      // setSliderButtonsPosition();
    }

    // window.addEventListener('resize', () => {
    //   if (timeline) {
    //     setSliderButtonsPosition();
    //   }
    // });
  }
}

Timeline.className = 'Timeline';
export default Timeline;
